import jwtDecode from "jwt-decode";
import moment from "moment";
import { authApi } from "@services/api";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

const isTokenExpire = (token) => {
  const { exp } = jwtDecode(token);
  const secondsLeft = exp - moment().unix();
  if (secondsLeft < 100) return true;
  return false;
};
export const getAccessToken = async () => {
  const accessToken = Cookies.get(process.env.REACT_APP_USER_TOKEN) || null;
  const refreshToken = Cookies.get(process.env.REACT_APP_REFRESH_TOKEN) || null;

  if (!accessToken || !refreshToken) return false;
  if (isTokenExpire(accessToken)) {
    try {
      const tokens = await authApi.refreshToken({ accessToken, refreshToken });
      const { data } = tokens.data;
      Cookies.set(process.env.REACT_APP_USER_TOKEN, data.accessToken);
      Cookies.set(process.env.REACT_APP_REFRESH_TOKEN, data.refreshToken);
    } catch (error) {
      const { status } = error.response;
      if (status === 401)
        toast.warn(
          "Your session has ended, please sign in again. You will be sign out automatically in a few seconds",
          {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            onClose: () => {},
          }
        );
    }
  }
  return accessToken;
};
